export default "__VITE_ASSET__BwHsWKKo__"